/**
 * 支付方式枚举
 */
export const PayChannels = Object.freeze({
  /** 微信支付 */
  TenPay: 1,
  /** 支付宝 */
  Alipay: 2,
  /** 微信支付(汇付) */
  TenPayHF: 3,
  /** 支付宝(汇付) */
  AlipayHF: 4,
  /** 银联公对公(汇付) */
  B2BHF: 5
});
